import { formatDate } from '@/utils/format'

export function poiSettings(state) {
    return state.poiSettings
}

export function queryPoiSettings(state) {
    return state.queryPoiSettings
}

export function fullPoiSettings(state) { // regular poi settings and query poi settings
    return {...state.poiSettings, ...state.queryPoiSettings}
}

export function poiSettingsChanged(state) {
    return state.poiSettingsChanged
}

export function queryPoiSettingsChanged(state) {
    return state.queryPoiSettingsChanged
}

export function routeSettings(state) {
    return state.routeSettings
}

export function activeRouteSettings(state) {
    if(state.savedRouteSettings) return state.savedRouteSettings
    if(state.queryRouteSettings) return state.queryRouteSettings
    return state.routeSettings
}

export function routeSettingsChanges(state) {
    return state.routeSettingsChanges
}

export function savedRouteSettings(state) {
    return state.savedRouteSettings
}

export function savedRouteSettingsChanges(state) {
    return state.savedRouteSettingsChanges
}

export function savedRouteSettingsActive(state) {
    return state.savedRouteSettings ? true : false
}

export function queryRouteSettings(state) {
    return state.queryRouteSettings
}

export function queryRouteSettingsChanges(state) {
    return state.queryRouteSettingsChanges
}

export function routeSettingsGeneralTypes(state) {
    return state.routeSettings.general.type
}

export function routeSettingsChanged(state) {
    return state.routeSettingsChanged;
}

export function routeTrafficTime(state) {
    return state.routeTrafficTime
}

export function savedRouteTime(state) {
    return state.savedRouteTime
}

export function routeTimeDateFormatted(state) {
    if(state.routeTrafficTime.isNow) {
        const today = new Date()
        return formatDate(today)
    } else {
        return formatDate(state.routeTrafficTime.date)
    }
}

export function selectedFuelType(state) {
    if(state.queryPoiSettings) {
       return state.queryPoiSettings.gasStations.fuels[0] 
    }
    return state.poiSettings.gasStations.fuels[0]
}

export function routeCorridorRadius(state) {
    return state.routeCorridorRadius
}

export function gasConsumptionSettings(state) {
    return state.gasConsumptionSettings
}